function Footer() {
  return <footer>Developed By Vivek</footer>;
}

export { Footer };
